import { render, staticRenderFns } from "./docsList.vue?vue&type=template&id=3abf647f&"
import script from "./docsList.vue?vue&type=script&lang=js&"
export * from "./docsList.vue?vue&type=script&lang=js&"
import style0 from "./docsList.vue?vue&type=style&index=0&id=3abf647f&prod&lang=css&"
import style1 from "./docsList.vue?vue&type=style&index=1&id=3abf647f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports